import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('project-list/index', {params});
    },
    getProject(params) {
        return Service().get('project-list/get-project', {params});
    },
    show(id) {
        return Service().get('project-list/show/'+id);
    },
    create(params) {
        return Service().post('project-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('project-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('project-list/delete/'+id);
    },
}